/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nav_Dataroomandnda6Inputs */

const en_coinvestments_nav_dataroomandnda6 = /** @type {(inputs: Coinvestments_Nav_Dataroomandnda6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Room and NDA`)
};

/**
* | output |
* | --- |
* | "Data Room and NDA" |
*
* @param {Coinvestments_Nav_Dataroomandnda6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nav_dataroomandnda6 = /** @type {((inputs?: Coinvestments_Nav_Dataroomandnda6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nav_Dataroomandnda6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nav_dataroomandnda6(inputs)
});
export { coinvestments_nav_dataroomandnda6 as "coInvestments_nav_dataRoomAndNDA" }